(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.PXUTheme = root.PXUTheme || {};
    root.PXUTheme.cartOffer = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  function calculate(totalCents, thresholdCents) {
    const total = Math.max(Number(totalCents) || 0, 0);
    const threshold = Math.max(Number(thresholdCents) || 0, 0);
    const complete = threshold === 0 || total >= threshold;
    const progress = threshold === 0 ? 100 : Math.min((total / threshold) * 100, 100);

    return {
      complete,
      progress,
      remainingCents: complete ? 0 : Math.max(threshold - total, 0),
    };
  }

  return { calculate };
}));
